module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAM9JREFUOE/t0jEKwkAQBdD/zQG09lBGPISWFupiI2wjaKxsA17AQiIWabyGra2IveWOBI2EsMlGSBXcdoe3O3+GqPmwZg9/0J6o+LMlPG/Hw+rqyrxShuKrLQxDntaXhoKidYtam7Q9W8v5mrTWmqH46gzDcZpZHpS+WgByZ7QJ85nawZ7qgtjDcJSgWfCNocMomNgGVDhlyaBoyTCZMjwZAGgzCqZF0y5dmy9KPCHyAHkrw5JHnHv4QWMAMY/BvJY9dCHZe+cPf8Eqtdw88AWj1l8ViUCWuQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_icon_arrow_drop.png
// module id = L7UR
// module chunks = 0